import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Button } from '../../shared/button/Button';
import styles from './ClientRiskTolerance.module.scss';
import { getIsSaving, getRiskToleranceHasUpdated, getUnsavedChangesModalOpen, ClientRiskToleranceView, saveRiskToleranceStarted, setClientRiskToleranceView, toggleUnsavedChangesModal, getRiskToleranceIncludesOverrides, toggleRiskFieldsUpdatedModal } from './store';
import { UnsavedChangesModal } from '../../shared/modal/UnsavedChangesModal';

export const MyDatasetsButtons: React.FC = () => {
    const dispatch = useAppDispatch();

    const isSaving = useAppSelector(getIsSaving);
    const riskToleranceUpdated = useAppSelector(getRiskToleranceHasUpdated);
    const riskToleranceIncludesOverrides = useAppSelector(getRiskToleranceIncludesOverrides);
    const unsavedChangesModalOpen = useAppSelector(getUnsavedChangesModalOpen);

    const toggleUnsavedChangesModalOpen = useCallback((isOpen: boolean) => dispatch(toggleUnsavedChangesModal(isOpen)), [dispatch]);
    const back = useCallback(() => dispatch(setClientRiskToleranceView(ClientRiskToleranceView.LIST, null)), [dispatch]);
    const onBackClick = useCallback(() => riskToleranceUpdated ? toggleUnsavedChangesModalOpen(true) : back(), [riskToleranceUpdated, toggleUnsavedChangesModalOpen, back]);
    const saveRiskTolerance = useCallback(() => riskToleranceIncludesOverrides ? dispatch(toggleRiskFieldsUpdatedModal(true)) : dispatch(saveRiskToleranceStarted()), [dispatch, riskToleranceIncludesOverrides]);

    const saveRiskToleranceDisabled = useMemo(() => isSaving || !riskToleranceUpdated, [isSaving, riskToleranceUpdated]);
    const wrapperStyle = useMemo(() => ({ width: 'calc(100% - 20px)', padding: '0 10px' }), []);

    return (
        <div className={styles.buttonWrapper} style={wrapperStyle}>
            <div>
                <Button onClick={onBackClick} label='Back' />
            </div>
            <div className={styles.rightButtonsWrapper}>
                <Button onClick={saveRiskTolerance} label='Save' disabled={saveRiskToleranceDisabled} />
            </div>
            <UnsavedChangesModal isOpen={unsavedChangesModalOpen} closeModal={() => toggleUnsavedChangesModalOpen(false)} confirm={back} />
        </div>
    );
};
